import moment from 'moment';

export const DisplayDateFormat = (
  dateString: string | null | undefined,
  fullYear?: boolean
): string => {
  return dateString ? moment(dateString).format(fullYear ? 'DD.MM.YYYY' : 'DD.MM.YY') : '';
};

export const DisplayLongDateFormat = (dateString: string | null | undefined): string => {
  return dateString ? moment(dateString).format('DD.MM.YYYY - HH:mm') : '';
};
